import { graphQLClient } from '@settings/services/graphQLClient';
import { GraphQLClient } from '@settings/services/graphQLClient/GraphQLClient';
import { loggerFactory } from '@settings/services/logger';

import { RouteCalculatorSettingsServiceInterface } from './interface';
import {
  LoadRouteCalculatorSettingsQuery,
  LoadRouteCalculatorSettingsQueryResponse,
  RouteCalculatorSettings,
} from './queries/LoadRouteCalculatorSettingsQuery';

class RouteCalculatorSettingsService implements RouteCalculatorSettingsServiceInterface {
  private readonly logger = loggerFactory().make(`RouteCalculatorSettingsService`);
  private readonly client: GraphQLClient;

  constructor(token?: string) {
    this.client = graphQLClient(token);
  }

  async Load(): Promise<RouteCalculatorSettings> {
    try {
      const { data } = await this.client.Query<null, LoadRouteCalculatorSettingsQueryResponse>(
        new LoadRouteCalculatorSettingsQuery(),
        {}
      );

      this.logger.Debug(`Load route calculator settings`, data);

      return data;
    } catch (e) {
      this.logger.Error(e);

      throw e;
    }
  }
}

export default RouteCalculatorSettingsService;
